import React from 'react';
import type { FieldProps } from '../types';

/**
 * RadioField Component
 *
 * Renders radio button group.
 */
export const RadioField: React.FC<FieldProps> = ({
  element,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  theme,
}) => {
  const properties = element.properties;
  const options = properties?.options || [];

  return (
    <div className="mediform-field mediform-radio-field">
      {properties?.label && (
        <div className="mediform-field-label">
          {properties.label}
          {properties.required && <span className="mediform-required"> *</span>}
        </div>
      )}

      <div className="mediform-radio-group" role="radiogroup" aria-label={properties?.label}>
        {options.map((option) => {
          const optionId = `${element.id}-${option.value}`;
          const isSelected = value === option.value;

          return (
            <label
              key={option.value}
              htmlFor={optionId}
              className={`mediform-radio-option ${isSelected ? 'mediform-radio-selected' : ''}`}
            >
              <input
                type="radio"
                id={optionId}
                name={element.id}
                value={option.value}
                checked={isSelected}
                onChange={() => onChange(option.value)}
                onBlur={onBlur}
                disabled={disabled}
                required={properties?.required}
                className="mediform-radio-input"
              />
              <span className="mediform-radio-label">{option.label}</span>
              {option.score !== undefined && (
                <span className="mediform-radio-score">({option.score})</span>
              )}
            </label>
          );
        })}
      </div>

      {error && (
        <div className="mediform-field-error" style={{ color: theme?.colors?.error }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default RadioField;
